import { render, staticRenderFns } from "./modular.vue?vue&type=template&id=d5f74b14"
import script from "./modular.vue?vue&type=script&lang=js"
export * from "./modular.vue?vue&type=script&lang=js"
import style0 from "./modular.vue?vue&type=style&index=0&id=d5f74b14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports